//import SendLocalKatalkPopup from "@/pages/comp/basic/katalk/local_katalk/popup/send_local_katalk";
import SendLocalKatalkArea from "@/pages/comp/basic/katalk/local_katalk/common/send_local_katalk";

function SendLocalKatalkPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    msg_arr:[],//[{room_name:"",message:""}]
    ...props
  };

  return (
    <>
      <SendLocalKatalkArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        msg_arr={myProps.msg_arr}
      ></SendLocalKatalkArea>
    </>
  );
};
export default SendLocalKatalkPopup;